<section class="d-flex justify-content-between align-items-center w-100">
    <ul class="d-flex breadcrumb-list" data-uit="breadcrumb-list">
        <li *ngFor="let breadcrumbPart of breadcrumbParts; last as isLast" class="d-flex align-items-center font-m">
            <div class="d-flex align-items-center" *ngIf="!isLast; else last">
                <a [routerLink]="breadcrumbPart.route" [queryParams]="breadcrumbPart.queryParams">{{
                    breadcrumbPart.titleKey | translate: breadcrumbPart.titleParams
                }}</a>
                <ca-icon name="arrow-right" size="s" class="link-icon ms-2 me-2"></ca-icon>
            </div>
            <ng-template #last>
                {{ breadcrumbPart.titleKey | translate: breadcrumbPart.titleParams }}
            </ng-template>
        </li>
    </ul>
</section>
